<template>
  <div class="chat-page" id="chat-page">
    <!-- 遮罩层 -->
    <div
      class="mask"
      v-if="showInput"
      @touchmove.prevent.stop="bindTouchmove"
      @mounsemove.prevent.stop="bindTouchmove"
      @click.stop="showInput = false"
    ></div>
    <div class="chat-content">
      <div class="chat-box" v-if="!showInput">
        <div class="input-text" @click.stop="resetInfo">
          <i class="iconfont icon-home_tab_message"></i>
          <span>说点什么...</span>
        </div>
        <div class="chat-right">
          <div
            class="chaticon collect"
            v-if="info.base.collect_info"
            @click.stop="collectDynamic"
          >
            <img
              class="c-icon"
              :src="getCollectIcon(info.base.collect_info.is_collect)"
              alt=""
            />
            <div class="iconfont-count">{{
              info.base.collect_info.number || 0
            }}</div>
          </div>
          <div
            class="chaticon like"
            :class="{ 'like-active': info.base.like_info.is_like }"
            @click.stop="likeDynamic"
          >
            <ZanIcon class="l-icon" :flag="info.base.like_info.is_like" />
            <div class="iconfont-count"
              >{{ info.base.like_info.number || 0 }}次鼓励</div
            >
          </div>
        </div>
      </div>
      <div class="chat-box" v-else>
        <div class="chat-left">
          <van-field
            ref="textarea"
            class="chat-input"
            rows="1"
            :maxlength="maxLength"
            :border="false"
            v-model="inputValue"
            type="textarea"
            @focus="bindFocus"
            @blur="bindBlur"
            :autosize="autosize"
            :placeholder="placeholder"
          />
        </div>
        <div class="chat-right">
          <div class="send" @click.stop="commentDynamic"> 发布 </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import ZanIcon from './zan.vue'
export default {
  props: {
    chatInfo: {
      type: Object,
      default: () => {
        return {}
      }
    },
    info: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  components: {
    ZanIcon
  },
  data() {
    return {
      autosize: {
        maxHeight: 72,
        minHeight: 24
      },
      maxLength: 2000, //最大评论文字
      showInput: false, //是否显示输入框
      inputValue: '' //用户输入的文字
    }
  },
  computed: {
    placeholder() {
      if (this.chatInfo.childNode) {
        return this.chatInfo.childNode.truename
          ? '回复' + this.chatInfo.childNode.truename
          : '写点什么吧！'
      }
      if (this.chatInfo.parentNode) {
        return this.chatInfo.parentNode.truename
          ? '回复' + this.chatInfo.parentNode.truename
          : '写点什么吧！'
      }
      return '写点什么吧！'
    }
  },
  watch: {
    showInput(val) {
      if (val) {
        this.$nextTick(() => {
          this.$refs.textarea.focus()
        })
      }
    }
  },
  mounted() {},
  methods: {
    getCollectIcon(flag) {
      return flag
        ? 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/762d32b08bd955a6d856dab74f0ad57e.png'
        : 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/238311191b2ef765ebf8104f14406a78.png'
    },
    getLikeIcon(flag) {
      return flag
        ? 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/c73e7e460544f7db1a959427432c6fb5.png'
        : 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/a72c1d0a7d610f2d40bffd7bd55d1e18.png'
    },
    focus() {
      this.showInput = true
    },
    bindTouchmove() {},
    //收藏
    collectDynamic() {
      this.$emit('collect')
    },
    //点赞动态
    likeDynamic(e) {
      this.$emit('like')
    },
    //评论动态
    commentDynamic() {
      if (this.inputValue === '') {
        return
      }
      this.$emit('comment', this.inputValue)
    },
    bindBlur() {},
    bindFocus() {},
    resetInfo() {
      this.$emit('reset')
      this.bindShowInput()
    },
    bindShowInput() {
      this.showInput = true
    },
    bindHideInput() {
      this.showInput = false
    },
    //完成评论
    confirmComment() {
      this.clearInput()
      this.showInput = false
    },
    //清空输入框
    clearInput() {
      this.inputValue = ''
    }
  }
}
</script>
<style lang="scss" scoped>
.chat-page {
  z-index: 999;
}
::v-deep .van-field__control {
  -webkit-appearance: none;
}
.mask {
  position: fixed;
  left: 0;
  top: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.3);
  z-index: 1;
}

.chat-content {
  position: fixed;
  left: 0;
  bottom: 0;
  width: 100%;
  z-index: 10;
  box-sizing: border-box;
  padding: 14px 16px 16px;
  @include paddingBottom(20px);
  background: #ffffff;
  box-shadow: inset 0px 1px 0px 0px #f7f7f7;
}

.chat-box {
  display: flex;
  align-items: center;
}

.chat-right {
  font-size: 2.7vw;
  display: flex;
  align-items: center;
}

.input-text {
  flex: 1;
  display: flex;
  align-items: center;
  margin-right: 4vw;
  height: 30px;
  background: #f1f1f1;
  margin-right: 16px;
  font-size: 12px;
  border-radius: 16px;
  padding: 0 16px;
  color: rgba(0, 0, 0, 0.3);
}

.input-text .iconfont {
  color: rgba(0, 0, 0, 0.19);
  margin-right: 4px;
}
.chat-left {
  box-sizing: border-box;
  flex: 1;
  flex-shrink: 0;
  background-color: #f1f1f1;
  margin-right: 4vw;
  border-radius: 3.7vw;
  overflow: hidden;
}
.chat-input {
  background-color: #f1f1f1;
  /* min-height: 17px;
  max-height: 136px; */
  font-size: 12px;
  padding: 5px 16px;
  box-sizing: border-box;
  color: rgba(0, 0, 0, 0.5);
}
::v-deep .van-field__control::placeholder {
  line-height: 24px;
}
.send {
  color: #6236ff;
  height: 8vw;
  line-height: 8vw;
  padding: 0vw 2.7vw;
  font-weight: 600;
  font-size: 3.5vw;
  border-radius: 4.7vw;
}

.like,
.attention,
.forward {
  margin-right: 2.7vw;
  display: flex;
  align-items: center;
}
.like {
  .l-icon {
    width: 20px;
    height: 20px;
    object-fit: contain;
    margin-right: 4px;
  }
}
.like-active {
  .iconfont-count {
    color: #6236ff;
  }
}
.chat-right {
  .chaticon {
    display: flex;
    align-items: center;
    margin-right: 15px;
  }
  .chaticon:last-child {
    margin-right: 0;
  }
}

.chaticon .iconfont {
  margin-right: 4px;
  color: #ccc;
}
.collect {
  .c-icon {
    width: 20px;
    height: 20px;
    object-fit: contain;
    margin-right: 8px;
  }
}

.forward .iconfont {
  font-size: 5.3vw;
}

.chat-right .icon-xihuanlike {
  color: #e50049;
}

.zan-content {
  width: 6.7vw;
  height: 6.7vw;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 1.1vw;
  position: relative;
}

.icon-xinxing {
  color: rgb(197, 197, 197);
  font-size: 4vw;
}

.icon-biaoqing {
  font-size: 6.7vw;
}

.zan-content,
.like-content {
  display: flex;
  align-items: center;
  flex-direction: column;
}

.iconfont-count {
  font-size: 2.7vw;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: rgba(0, 0, 0, 0.5);
  line-height: 3.7vw;
}
</style>
